import React from 'react';
import ConvocationPageShell from '../../components/ConvocationPageShell';
import MiyunLohamotStatic from './MiyunLohamotStatic';

const MiyunLohamot = () => (
  <ConvocationPageShell
    strapiApiId="convocation-miyun-lohamot"
    defaultTitle="Miyun Lohamot"
    StaticFallback={MiyunLohamotStatic}
  />
);

export default MiyunLohamot;
